import { analysisSpecApi } from '@/model/analysisSpec/api.generated';

export function registerAnalysisSpecTags(): void {
  analysisSpecApi.enhanceEndpoints({
    endpoints: {
      deleteApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecName: {
        invalidatesTags: ['analysis-specs', 'mining', 'artifacts', 'dashboards'],
      },
      postApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDuplicate: {
        invalidatesTags: ['analysis-specs', 'mining'],
      },
      getApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameDependentDashboards: {
        providesTags: ['dashboards'],
      },
      getApiProjectsByProjectIdAnalysisSpecsAndAnalysisSpecNameExport: {
        keepUnusedDataFor: 0,
      },
      getApiAnalysisSpecsExportDownload: {
        keepUnusedDataFor: 0,
      },
    },
  });
}
